import type { Mutation, MutationCreateCreditDonationArgs } from '@ab-core/graphql/dist';
import { useMutation } from '@apollo/client';
import { useCallback, useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { CREATE_CREDIT_DONATION } from './gql/createCreditDonation';

type MutationDataType = Pick<Mutation, 'createCreditDonation'>;
type ResponseDataType = MutationDataType | undefined;

const onError = getErrorLoggerFunction('createCreditDonation');

export const useCreateCreditDonation = () => {
    const [response, setResponse] = useState<ResponseDataType>(undefined);

    const [createCreditDonation, { loading, error, data }] = useMutation<
        MutationDataType,
        MutationCreateCreditDonationArgs
    >(CREATE_CREDIT_DONATION, {
        onError
    });

    const outgoingCreateCreditDonation = useCallback(
        (credits: MutationCreateCreditDonationArgs) => {
            createCreditDonation({ variables: credits });
        },
        [createCreditDonation]
    );

    useEffect(() => {
        if (data) {
            setResponse(data);
        }
    }, [data]);

    return {
        success: !!data,
        error: !!error,
        createCreditDonation: outgoingCreateCreditDonation,
        loading,
        response
    };
};
